import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // Note: We rely on Authorization header (Bearer JWT) instead of cookies,
  // because the preview ingress responds to OPTIONS preflight with
  // `Access-Control-Allow-Origin: *`, which browsers reject when credentials=include.
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

// Attach token from localStorage as fallback (cookie should normally suffice)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bloq_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
